import Moment from 'moment'
import MomentTimezone from 'moment-timezone'

export default

    class DateHelper {

    constructor() {
        throw new Error('Dont\'t permitted instancing DateHelper');
    }

    static dateToString(date) {
        if (!DateHelper._validateDate(date)) {
            throw new Error('Invalid date format');
        }
        return `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`;
    }

    static stringToDate(date) {
        if (!DateHelper._validateDate(date)) {
            throw new Error('Invalid date format');
        }
        return new Date(...
            date.split('-')
                .map((data, i) => data - i % 2)
        );
    }

    static dateTimeToDateObj(datetime) {
        let date = new Date(datetime);
        return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDay() }
    }

    static datetimeToDate(datetime) {
        let date = new Date(datetime);
        return `${date.getDay()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    static formatDatetime(datetime) {
        return MomentTimezone(datetime)
            .tz('UTC')
            .format('DD/MM/YYYY HH:mm');
    }

    static formatDate(datetime) {
        return MomentTimezone(datetime)
            .tz('UTC')
            .format('DD/MM/YYYY');
    }

    static formatTime(time) {
        return MomentTimezone(time, "HH:mm:ss")
            .tz('UTC')
            .format('HH:mm');
    }

    static subtractHours(datetimeOne, datetimeTwo) {
        let hoursOne = Moment(datetimeOne).hours();
        let hoursTwo = Moment(datetimeTwo).hours();

        return hoursOne - hoursTwo;
    }

    static _validateDate(date) {
        let valid = false;
        if ((date instanceof Date) || /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            valid = true;
        }
        return valid;
    }

    static getDateFormatMonthYear() {
        let moment = Moment().locale('pt-br')
        let arrayDate = []
        let year = Moment().toObject().years
        moment.localeData().months().forEach(element => {
            arrayDate.push(`${element}/${year}`)
        });

        return arrayDate
    }

    static getCurrentMonthYear() {
        let moment = Moment().locale('pt-br')
        return `${moment.localeData().months()[moment.month()]}/${Moment().toObject().years}`
    }

    static getCurrentDay() {
        return Moment().tz('America/Sao_Paulo').format('YYYY-MM-DD')
    }

    static formatDateTimeToDate(datetime) {
        return datetime.substring(0, 10);
    }
    static stringBarrastoDate(dateStr) {
        var parts = dateStr.split("/");
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }
}
